import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import './interactions/treemap-drill-down';
import '../scatter/interaction';

var Treemap =
/** @class */
function (_super) {
  __extends(Treemap, _super);

  function Treemap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'treemap';
    return _this;
  }

  Treemap.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Treemap;
}(Plot);

export { Treemap };